import { useClientId, useCopyPasteStyles, useDeviceType } from "@blocks/hooks";
import { withSelect } from "@wordpress/data";
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { EditProps } from "blocks/types";
import classnames from "classnames";
import React from "react";
import { useBlockStyle } from "../../hooks";
import "../assets/sass/blocks/heading/style.scss";
import InspectorControls from "./components/InspectorControls";

interface Props extends EditProps<any> {
	postTitle?: string;
	excerpt?: string;
}

const Edit: React.FC<Props> = (props) => {
	const {
		className,
		attributes: {
			enableExcerpt,
			markup,

			hideOnDesktop,
		},
		setAttributes,
		postTitle,
		excerpt,
	} = props;

	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "post-title",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	const classNames = classnames(
		`mzb-post-title mzb-post-title-${clientId}`,
		className,
		hideOnDesktop && "magazine-blocks-hide-on-desktop"
	);

	const TagName = markup || "h2";

	return (
		<Fragment>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			<div className={classNames}>
				<TagName className="mzb-post-title__title">
					{postTitle || __("Post Title", "magazine-blocks")}
				</TagName>
				{enableExcerpt && (
					<p className="mzb-post-title__excerpt">
						{excerpt || __("Post Excerpt", "magazine-blocks")}
					</p>
				)}
			</div>
		</Fragment>
	);
};

// @ts-ignore
export default withSelect((select) => {
	const { getCurrentPost } = select("core/editor");
	const post = getCurrentPost();
	return {
		postTitle: post?.title || "",
		excerpt: post?.excerpt || "",
	};
})(Edit);
